import React, { FC } from "react";
import styled from "styled-components";
import { BrowserRouter, Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import Header, { HeaderMobileMenuClose } from "../header";
import { centralized } from "../styled";
import Grid from "../grid";
import { FormattedMessage } from "react-intl";

const debug: FC = () => {
    return (
        <BrowserRouter>
            <FullScreenMenu
                onClose={() => {
                    console.log("close");
                }}
            ></FullScreenMenu>
        </BrowserRouter>
    );
};

export const FullScreenMenu: FC<{ onClose?: () => void }> = ({ onClose }) => {
    // TODO: - Refactor out onClose in every element
    return (
        <>
            <Grid>
                <Header>
                    <HeaderMobileMenuClose onClick={() => onClose?.()} />
                </Header>
                <Layout>
                    <MenuLink to='/#product' onClick={() => onClose?.()}>
                        <FormattedMessage id='header.products' />
                    </MenuLink>
                    <MenuLink to='/blog' onClick={() => onClose?.()}>
                        <FormattedMessage id='header.blog' />
                    </MenuLink>
                    <MenuBookDemoLink to='/#demo' onClick={() => onClose?.()}>
                        <FormattedMessage id='header.conversion_button' />
                    </MenuBookDemoLink>
                </Layout>
            </Grid>
        </>
    );
};

const MenuHeader = styled.div`
    display: grid;
    grid-auto-flow: column;
    height: 70px;
    padding: 15px 10px;
    ${centralized};
`;

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
`;

const MenuLink = styled(HashLink)`
    text-decoration: none;
    font-weight: 600;
    font-size: 24px;
    line-height: 153%;
    color: #2770d8;
`;

const MenuBookDemoLink = styled(HashLink)`
    text-decoration: none;
    font-weight: 600;
    font-size: 24px;
    line-height: 153%;
    color: #e38146;
`;
